import * as React from "react";
import "./ProductQtyCtl.scss";
import SelectCtl from "./input/SelectCtl";
import IntegerCtl from "./input/IntegerCtl";
import CurrencyCtl from "./input/CurrencyCtl";
import LabelCtl from "./input/LabelCtl";
import Constants from "./Constants";
import { ItemNumber } from "@testout/testout-commerce/models/commerce/ItemNumber";
import { ListItem } from "@testout/testout-commerce/models/ListItem";
import { SalesItem } from "@testout/testout-commerce/models/commerce/SalesItem";
import { SalesBase } from "@testout/testout-commerce/models/commerce/SalesBase";

interface ProductQtyCtlProps {
    item: SalesItem;
    salesBase?: SalesBase;
    productSelectItems?: ListItem[];
    customerList?: ListItem[];
    deleteItem?: Function;
    onChange?: (value: SalesItem) => void;
    hidePriceDropDown?: boolean;
    hideCustomerDropDown?: boolean;
    hidePrice?: boolean;
    hideQtyEdit?: boolean;
    hideDelete?: boolean;
    isLocked?: boolean;
    showLock?: boolean;
    disabled: boolean;
}

const emptyArray = new Array<ListItem>();

export default class ProductQtyCtl extends React.PureComponent<ProductQtyCtlProps> {

    changeProduct = (value: string) => {
        let newItem = new SalesItem(this.props.item, this.props.salesBase);
        newItem.productNumber = new ItemNumber(value);
        newItem.unitCode = this.props.salesBase?.pricing?.priceList?.prices.find(p => p.productNumber === value)?.unitCode ?? "Each";
        this.props.onChange?.(newItem);
    };

    changeCustomer = (value: string) => {
        let newItem = new SalesItem(this.props.item, this.props.salesBase);
        newItem.customerNumber = value;
        this.props.onChange?.(newItem);
    };

    changeQuantity = (value: number) => {
        let newItem = new SalesItem(this.props.item, this.props.salesBase);
        newItem.quantity = value;
        this.props.onChange?.(newItem);
    };

    changePrice = (value: number) => {
        let newItem = new SalesItem(this.props.item, this.props.salesBase);
        newItem.unitPrice = value;
        this.props.onChange?.(newItem);
    };

    changeOverride = () => {
        let newItem = new SalesItem(this.props.item, this.props.salesBase);
        newItem.overridePricing = !newItem.overridePricing;
        this.props.onChange?.(newItem);
    };

    deleteMe = () => {
        if (this.props.deleteItem !== undefined)
            this.props.deleteItem(this.props.item.itemId);
    };

    render() {
        return <div className="productQty">
            {!(this.props.hidePriceDropDown ?? false) && <div>
                <SelectCtl value={this.props.item.productNumber.toString()} errorMessage={this.props.item.productNumber.toString() !== Constants.NEW_PRODUCT_LINE &&
                    !this.props.productSelectItems?.find(p => p.value === this.props.item.productNumber.toString()) ? "Product not found in the current price list" : ""}
                    onChange={this.changeProduct} items={this.props.productSelectItems ?? emptyArray} hideItemValue={true} disabled={this.props.disabled} />
            {!(this.props.hideCustomerDropDown ?? false) &&
                <SelectCtl value={this.props.item.customerNumber ?? Constants.MAIN_SCHOOL} errorMessage={
                    !this.props.customerList?.find(p => p.value === (this.props.item.customerNumber ?? Constants.MAIN_SCHOOL)) ? "Child customer not found for the current customer" : ""}
                    onChange={this.changeCustomer} items={this.props.customerList ?? emptyArray} hideItemValue={true} disabled={this.props.disabled} />}
            </div>}
            {(this.props.hidePriceDropDown ?? false) && <div className="productName">{this.props.item.title ?? ""} </div>}
            <div>{!(this.props.hideQtyEdit ?? false) && <IntegerCtl value={this.props.item.quantity} onChange={this.changeQuantity} disabled={this.props.disabled} />}</div>
            <div>{!(this.props.hidePrice ?? false) && <CurrencyCtl value={this.props.item.unitPrice} onChange={this.changePrice} changeOverride={this.changeOverride} showLock={this.props.showLock} isLocked={this.props.isLocked} disabled={this.props.disabled} />}</div>
            <div>{!(this.props.hidePrice ?? false) && <LabelCtl label={((this.props.item.unitPrice ?? 0) * (this.props.item.quantity ?? 0)).toLocaleString("en-US", { style: "currency", currency: "USD" })} />}</div>
            <div>{!this.props.hideDelete && !this.props.disabled && <button className="trash" onClick={this.deleteMe} disabled={this.props.disabled}>&nbsp;</button>}</div>
        </div>;
    }
}